import * as BusinessDAL from '../dal/business-dal'
import * as UserDAL from '../dal/user-dal'
import * as OrderDAL from '../dal/order-dal'
import * as InitService from './init-service.js';
import {
  user,
  business,
  isAdmin,
  loyaltyRules,
  addVisit,
  orders,
  userDetails,
} from "../stores.js";
import { get } from "svelte/store";



export async function getBusiness(code) {
  if (!code) throw new Error("getBusiness called with null code")
  return new Promise(async (resolve, reject) => {
    try {
      InitService.onInitComplete(async () => {
        await BusinessDAL.listenToLoyaltyRules(code, docs => {
          loyaltyRules.set(docs);
        })

        await BusinessDAL.listenToBusiness(code, async (doc) => {
          if (!doc) {
            business.set(null);
            reject("Not Found");
          } else {
            let b = doc;
            b.menu = JSON.parse(b.menu);
            b.code = code;
            business.set(b);
            addVisit(b);

            let u = get(user);
            if (u) {
              isAdmin.set(b.admins[u.uid]);
              checkAdmin()
            }

            resolve("loaded");
          }
        })
      })
    } catch (e) {
      reject(e);
    }

  });
}

export async function checkAdmin() {
  let _isAdmin = get(isAdmin);
  let b = get(business);
  if (_isAdmin && b) {
    OrderDAL.getOrders(b.code, 50, (_orders) => {
      orders.set(_orders);
    }, (err) => {
      console.error(err)
    });
  } else {
    OrderDAL.unsubOrders();
  }
}

export async function listenToUserLoyaltyCards(userDetailsObject) {
  if (!userDetailsObject || !userDetailsObject.loyaltyCards) return null;
  for (let id in userDetailsObject.loyaltyCards) {
    let loyaltyCard = userDetailsObject.loyaltyCards[id];
    if (!loyaltyCard) {
      UserDAL.sendLog("getLoyaltyCards", `not found ${id}`);
      continue;
    }
    if (!loyaltyCard.businessId) {
      UserDAL.sendLog("getLoyaltyCards", `Found loyaltyCard without businessId: ${id}`);
      continue;
    }
    BusinessDAL.listenToLoyaltyRule(loyaltyCard.businessId, id, (rule) => {
      if (!rule) {
        UserDAL.sendLog("listenToLoyaltyRule", `Couldn't find loyalty rule: ${loyaltyCard.businessId}/loyaltyRules/${id}`);
        return;
      }

      loyaltyCard.details = rule;
      userDetails.set(userDetailsObject)
    });
  }
  return userDetailsObject.loyaltyCards;
}


export async function saveNewLoyaltyRule(rule) {
  let b = get(business);

  await BusinessDAL.addNewLoyaltyRule(b.code, rule)
}

export async function updateLoyaltyRule(rule) {
  let b = get(business);

  await BusinessDAL.updateLoyaltyRule(b.code, rule.id, rule)


}


